export const setUserEmail = (email) => {
  return {
    type: "SET_LOGGED_IN_USER_EMAIL",
    email,
  };
};
export const setRegisteredUserEmail = (email) => {
  return {
    type: "SET_REGISTERED_USER_EMAIL",
    email,
  };
};
export const setUserDetails = (userInfo) => {
  return {
    type: "SET_USER_DETAILS",
    userInfo,
  };
};
export const setCurrentSession = (userEmail) => {
  return {
    type: "SET_CURRENT_SESSION",
    userEmail,
  };
};
export const resetUserState = () => {
  return {
    type: "RESET_USER_STATE",
  };
};
